module.exports = __webpack_public_path__ + "static/img/parallel-traffic.2fd758a.jpg";